import apiClient from "./axios";

/**
 * 航段相关API
 */
const flightLegApi = {
    /**
     * 获取航段列表
     * @param {Object} params - 请求参数 (应包含 page 和 page_size)
     * @returns {Promise<Array>} 航段列表
     */
    getFlightLegList: async (params = {}) => {
        try {
            // 前端已传入 page 和 page_size, 直接使用
            // 后端已适配 page 和 page_size
            const response = await apiClient.get("/v1/flight-legs", { params });
            return response;
        } catch (error) {
            console.error("获取航段列表失败:", error);
            throw error;
        }
    },

    /**
     * 获取单个航段信息
     * @param {string} departureAirport - 出发机场
     * @param {string} arrivalAirport - 到达机场
     * @param {boolean} silentOn404 - 404时是否静默（不打印错误且不显示全局提示），默认false
     * @returns {Promise<Object>} 航段信息
     */
    getFlightLegByRoute: async (departureAirport, arrivalAirport, silentOn404 = false) => {
        try {
            // 如果设置了静默模式，添加配置跳过全局错误提示
            const config = silentOn404 ? { _silentError: true } : {};
            const response = await apiClient.get(`/v1/flight-legs/${departureAirport}/${arrivalAirport}`, config);
            return response;
        } catch (error) {
            // 如果是404且设置了静默模式，直接抛出错误不打印日志
            // 404表示航段不存在，在检查重复时这是正常情况
            if (error.response?.status === 404 && silentOn404) {
                throw error;
            }
            console.error("获取航段信息失败:", error);
            throw error;
        }
    },

    /**
     * 创建航段
     * @param {Object} data - 航段数据
     * @returns {Promise<Object>} 创建结果
     */
    createFlightLeg: async (data) => {
        const response = await apiClient.post("/v1/flight-legs", data);
        return response;
    },

    /**
     * 更新航段
     * @param {Object} params - 参数对象 {id: {departure_airport, arrival_airport}, data: 更新数据}
     * @returns {Promise<Object>} 更新结果
     */
    updateFlightLeg: async (params) => {
        const { id, data } = params;

        // 验证必要参数
        if (!id || !id.departure_airport || !id.arrival_airport) {
            throw new Error("更新航段时缺少必要的ID参数");
        }
        if (!data) {
            throw new Error("更新航段时缺少数据参数");
        }

        const response = await apiClient.put(`/v1/flight-legs/${id.departure_airport}/${id.arrival_airport}`, data);
        return response;
    },

    /**
     * 删除航段
     * @param {Object|string} id - 航段ID对象或组合字符串
     * @returns {Promise<Object>} 删除结果
     */
    deleteFlightLeg: async (id) => {
        if (typeof id === "object" && id.departure_airport && id.arrival_airport) {
            const response = await apiClient.delete(`/v1/flight-legs/${id.departure_airport}/${id.arrival_airport}`);
            return response;
        }
        const response = await apiClient.delete(`/v1/flight-legs/${id}`);
        return response;
    },
};

export default flightLegApi;
